import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackShowPhone } from './tracking';
import { CallButton } from '../../CallButton';
import { gaLabelSelector, newbuildingIdSelector } from '../../../selectors/newbuilding';
import { IPromoInfo } from '../../../types/newbuilding/promoInfo';

export interface IActionButtonContainerProps {
  authorRealtyUserId?: number;
  hasContacts: boolean;
  promo: IPromoInfo;
}

export const ActionButtonContainer: React.FC<IActionButtonContainerProps> = props => {
  const { hasContacts, authorRealtyUserId, promo } = props;
  const gaLabel = useSelector(gaLabelSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, promo, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  /* istanbul ignore next */
  const onOpenContactsClick = React.useCallback(() => {
    trackShowPhone(gaLabel, promo, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  /* istanbul ignore next */
  if (!hasContacts) {
    return null;
  }

  return (
    <CallButton
      placeType={'Promo'}
      realtyUserIdToDisplayPhone={authorRealtyUserId}
      onOpenContactsClick={onOpenContactsClick}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'M' as const, fullWidth: true }}
      showPhoneStyles={{ size: 'M' as const, fullWidth: true }}
    />
  );
};
